import { boolean, number, object, nativeEnum } from 'zod';

import { DeleteAccountMutation } from '@ocx/graphql';

const deleteAccountMutation = nativeEnum(DeleteAccountMutation).optional();

export const MembershipConfigOverridesSchema = object({
  walletEnabled: boolean().optional(),
  prepaidCardsEnabled: boolean().optional(),
  payInsideEnabled: boolean().optional(),
  payAtPumpEnabled: boolean().optional(),
  deleteAccountEnabled: boolean().optional(),
  deleteAccountMutation: deleteAccountMutation,
  appRatingEnabled: boolean().optional(),
  productInterestsEnabled: boolean().optional(),
  productInterestsEAIVPromotionOnProfileCompletedEnabled: boolean().optional(),
  eaivAgeVerificationEnabled: boolean().optional(),
  eaivIdentityVerificationEnabled: boolean().optional(),
  promptIntervalDays: number().optional(),
  transactionHistoryLookupDays: number().optional(),
  totalAvailableRollbackEnabled: boolean().optional(),
  loyaltyProgramPromocodesEnabled: boolean().optional(),
  mobilePaymentsReceiptsViewEnabled: boolean().optional(),
}).strict();

export const MembershipCustomDataSchema = object({
  configOverrides: MembershipConfigOverridesSchema.optional(),
});
